import { db, storage, auth } from 'common/config/Firebase'

export const signInPortalAnon = async () => {
    if (!auth.currentUser) await auth.signInAnonymously()
}

export const logoutPortal = () => {
    localStorage.removeItem('portal_email')
    window.location.reload()
}

export const getClientByEmail = async (email) => {
    // Try exact match, then lowercase (Firestore queries are case-sensitive)
    for (const variant of [email, email.toLowerCase()]) {
        const snap = await db.collection('clients').where('mail', '==', variant).limit(1).get()
        if (!snap.empty) return { id: snap.docs[0].id, ...snap.docs[0].data() }
    }
    return null
}

export const subscribeTasksByDni = (dni, callback) =>
    db.collection('tasks').where('dni', '==', dni).onSnapshot(snap =>
        callback(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    )

export const getTaskDetail = async (id) => {
    const doc = await db.collection('tasksDetail').doc(id).get()
    return doc.data() || {}
}

export const getInvoicesByDni = async (dniClient) => {
    const snap = await db.collection('invoices').where('dniClient', '==', dniClient).get()
    return snap.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => (b.invoiceDate || 0) - (a.invoiceDate || 0))
}

export const computeNumInvoice = (invoice, allInvoices) => {
    const isCanje = invoice.type === 'Canje'
    const sameType = allInvoices
        .filter(inv => isCanje ? inv.type === 'Canje' : inv.type !== 'Canje')
        .sort((a, b) => (b.invoiceDate || 0) - (a.invoiceDate || 0))
    const idx = sameType.findIndex(inv => inv.id === invoice.id)
    if (idx === -1) return invoice.numInvoice || ''
    const num = sameType.length - idx
    return isCanje ? `C${num}` : num
}


export const getInvoiceDetail = async (invoiceId) => {
    const doc = await db.collection('invoiceDetail').doc(invoiceId).get()
    return doc.data() || { data: [] }
}

export const savePortalSignature = async (taskId, dataUrl) => {
    // Guardar en la misma ruta que usa el admin (sign tipo 1) para que se incruste en el PDF
    const ref = storage.ref().child(`${taskId}-1-sign.png`)
    await ref.putString(dataUrl, 'data_url')
    return ref.getDownloadURL()
}

export const applyPortalSign = async (taskId, signatureUrl) => {
    const taskSnap = await db.collection('tasks').doc(taskId).get()
    const task = taskSnap.data() || {}

    const update = {
        clientPortalSign: { signature: signatureUrl, signedAt: Date.now() },
        presupuestoAceptado: true,
        budgetAccept: 1,
        dateAccepted: task.dateAccepted || Date.now(),
    }

    // Si estaba en Pendiente confirmación (6) → pasar a Reparando (5)
    if (parseInt(task.state) === 6) {
        update.state = 5
    }

    return db.collection('tasks').doc(taskId).update(update)
}
